// extracted by mini-css-extract-plugin
module.exports = {"erg":"Form_erg__4fRrz"};